import { useReceiptStore } from "@elixir/stores";
import { InputFormField } from "ui";

export default function DueAmountInput() {
  const amountBeingSettled = useReceiptStore((state) => state.amountSettled);
  const setAmountBeingSettled = useReceiptStore(
    (state) => state.setAmountSettled
  );

  const paymodes = useReceiptStore((state) => state.paymodes);
  const setPaymodes = useReceiptStore((state) => state.setPaymodes);

  return (
    <InputFormField
      title="DUE AMOUNT:"
      alignment="horizontal"
      isRequired={true}
      value={amountBeingSettled?.toString()}
      onChange={(e) => {
        const parsedAmountDue = parseFloat(e.target.value || "0");
        setAmountBeingSettled(parsedAmountDue);
        const [firstPaymode, secondPaymode] = paymodes;
        if (!secondPaymode) {
          firstPaymode["amount"] = parsedAmountDue;
        } else {
          if (firstPaymode["amount"] > parsedAmountDue) {
            firstPaymode["amount"] = 0;
          }

          secondPaymode["amount"] = parsedAmountDue - firstPaymode["amount"];
        }

        setPaymodes([firstPaymode, secondPaymode].filter(Boolean));
      }}
      width={180}
    />
  );
}
